module.exports = __webpack_public_path__ + "assets/img/7程序化报备.14f03376.jpg";